import { render, staticRenderFns } from "./restBookSummarySet2.vue?vue&type=template&id=2892f30c&scoped=true&"
import script from "./restBookSummarySet2.vue?vue&type=script&lang=js&"
export * from "./restBookSummarySet2.vue?vue&type=script&lang=js&"
import style0 from "./restBookSummarySet2.vue?vue&type=style&index=0&id=2892f30c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2892f30c",
  null
  
)

export default component.exports